define('vspot-angular/services/invitation-service',[], function () {
    'use strict';

    return ['resources.Invitation', function (Invitation) {

        return {
            /*
             * Get a list of all the invitations.
             *
             * @param  id - The activity to get the invitations for.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(accessKey) {
                return Invitation.query({ accesskey: accessKey });
            },

            get: function (activity_id, accesskey) {
                return Invitation.get({
                    activity_id: activity_id,
                    accesskey: accesskey,
                    id: activity_id // It's possible to authenticate with one activity and view another... but that's not yet implemented here
                });
            },
        };
    }];
});

